export const defaultRegisterCredentials = {
  email: "",
  password: "",
  firstName: "",
  lastName: "",
};
